import { createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { CoinMarketCalEvent, CoinMarketCalEventStream } from '@/types/generated/public_api'

export const useCoinMarketCalEventStream = createStreamHook<
  CoinMarketCalEventStream,
  CoinMarketCalEvent
>({
  channelKey: 'coinmarketcalEventStream',
  extractResponse: (message) => message.data?.coinmarketcalEvent,
  getPayloadDeps: () => [], // no fields — single global, unfiltered subscription
  listenerChannelKey: 'coinmarketcalEventStream',
})
